import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useAppState } from '../../../data';
import CookieDetail from './cookie-detail/CookieDetail';

const VendorsContainer = styled.section`
  height: 100%;
  width: 100%;
`;

const VendorsContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const VendorsListHeader = styled.div`
  height: 50px;
  padding-top: 15px;
  padding-right: 30px;
  padding-bottom: 15px;
  padding-left: 20px;
  display: inline-block;
  width: 100%;
  border-bottom: 1px solid #d8d8d8;

  @media (max-width: 600px) {
    padding: 15px 0;
  }
`;

const NavigationContainer = styled.div`
  float: left;

  @media (max-width: 600px) {
    display: block;
    text-align: left;
    float: none;
    padding-left: 15px;
  }
`;

const BackBtnHandler = styled.a`
  display: inline-block;
  text-decoration: none;
  color: #565656;
  cursor: pointer;
`;

const BackArrow = styled.div`
  height: 17px;
  width: 20px;
  vertical-align: middle;
  display: inline-block;
  color: dimgray;
  font-size: 1em;
  line-height: 1;
  text-align: center;
`;

const BackButtonText = styled.h3`
  color: #1C1C1C;
  font-size: .9em;
  font-weight: bold;
  line-height: 1;
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  padding-left: 5px;
`;

const VendorListContent = styled.section`
  flex: 1;
  width: 100%;
  padding-left: 80px;
  padding-right: 100px;
  padding-top: 20px;
  margin-right: 3px;
  margin-left: 0;
  overflow-x: hidden;
  overflow-y: auto;

  @media (max-width: 640px){
    padding-top: 13px;
    padding-right: 5px;
    padding-left: 10px;
  }
`;

const Row = styled.div`
  max-width: none;
  display: block;
  margin: 0;
  flex-direction: initial;
  width: 100%;
`;

const Column = styled.div`
  width: 100%;
  float: left;
`;

const HostListContainer = styled.ul`
  display: block;
  width: 100%;
  margin: 0;
  padding-left: 0;
  margin-top: 0;
  list-style: circle inside;
`;

const HostItem = styled.li`
  border: 1px solid #d7d7d7;
  border-radius: 2px;
  position: relative;
  margin: 0;
  margin-top: 10px;
  list-style: none;
`;

const AccordionHeader = styled.section`
  cursor: pointer;
  padding-top: 17px;
  padding-right: 15px;
  padding-bottom: 17px;
  padding-left: 20px;
  display: inline-block;
  width: 100%;
  vertical-align: middle;
`;

const ToogleGroup = styled.div`
  width: 65%;
  display: inline-block;
  vertical-align: middle;
`;

const HostInfo = styled.div`
  float: left;
  width: 100%;
`;

const HostTitle = styled.h3`
  color: #1C1C1C;
  position: relative;
  vertical-align: middle;
  font-weight: bold;
  font-size: .8em;
  line-height: 1.2;
  margin: 0;
  height: auto;
  text-align: left;
  word-break: break-word;
  word-wrap: break-word;
`;

const HostNotice = styled.div`
  float: right;
`;

const CookiesContainer = styled.div`
  float: left;
`;

const HostViewCookies = styled.a`
  color: ${props => props.color};
  font-size: .7em;
  line-height: .9;
  display: inline-block;
  text-decoration: none;
`;

const ArrowContainer = styled.div`
  float: right;
`;

const AccordionText = styled.div`
  transition: .1s ease-in;
  display: block;
  padding-top: 6px;
  padding-right: 50px;
  padding-bottom: 10px;
  padding-left: 50px;
  z-index: 2;
  position: relative;

  @media (max-width: 425px) {
    padding-right: 25px;
    padding-left: 25px;
  }
`;

const HostOptionGroup = styled.ul`
  display: inline-block;
  width: 100%;
  margin: 0;
  font-size: inherit;
  padding-left: 0;
  list-style: circle inside;
`;

const VendorHost = styled.li`
  color: #1C1C1C;
  border: none;
  font-size: .8em;
  float: left;
  text-align: left;
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;
  background-color: #f8f8f8;
  border-radius: 2px;
  position: relative;
  margin: 0;
  margin-top: 10px;
  list-style: none;
`;

interface ICookies {
  name: string;
  host: string;
  duration: string;
  category: string;
}

interface IHost {
  name: string;
  cookies: ICookies[];
}

export default function VendorsList() {
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const { showVendors, setShowVendors, appConfig, getTranslation } = useAppState();
  const hosts = appConfig.cookiesConfigs[showVendors].cookies
    .reduce<IHost[]>((acc, cookie) => {
      const host = acc.find(h => h.name === cookie.host);
      if (host) {
        host.cookies.push({
          category: appConfig.cookiesConfigs[showVendors].type,
          ...cookie
        });
      } else {
        acc.push({
          name: cookie.host,
          cookies: [{
            category: appConfig.cookiesConfigs[showVendors].type,
            ...cookie
          }]
        });
      }
      return acc;
    }, [])
    .map(host => {
      host.cookies.sort((a, b) => a.name.localeCompare(b.name));
      return host;
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  const handleClick = useCallback((index) => {
    setSelectedIndex((prev) => prev === index ? -1 : index);
  }, []);

  return (
    <VendorsContainer as="ldiv">
      <VendorsContent as="ldiv">
        <VendorsListHeader as="ldiv">
          <NavigationContainer as="ldiv">
            <BackBtnHandler as="ldiv" onClick={() => setShowVendors(-1)}>
              <BackArrow as="ldiv">
                <svg x="0px" y="0px" width="15px" height="15px" viewBox="0 0 444.531 444.531">
                  <title>{getTranslation('VENDORS_LIST_BACK_BUTTON_TITLE')}</title>
                  <g>
                    <path fill="#2c3643" d="M213.13,222.409L351.88,83.653c7.05-7.043,10.567-15.657,10.567-25.841c0-10.183-3.518-18.793-10.567-25.835 l-21.409-21.416C323.432,3.521,314.817,0,304.637,0s-18.791,3.521-25.841,10.561L92.649,196.425 c-7.044,7.043-10.566,15.656-10.566,25.841s3.521,18.791,10.566,25.837l186.146,185.864c7.05,7.043,15.66,10.564,25.841,10.564 s18.795-3.521,25.834-10.564l21.409-21.412c7.05-7.039,10.567-15.604,10.567-25.697c0-10.085-3.518-18.746-10.567-25.978 L213.13,222.409z"></path>
                  </g>
                </svg>
              </BackArrow>
              <BackButtonText as="ldiv">{getTranslation('VENDORS_LIST_BACK_BUTTON_LABEL')}</BackButtonText>
            </BackBtnHandler>
          </NavigationContainer>
        </VendorsListHeader>
        <VendorListContent as="ldiv">
          <Row as="ldiv">
            <Column as="ldiv">
              <HostListContainer as="ldiv">
                {hosts.map((host, index) => (
                  <HostItem as="ldiv" key={index}>
                    <AccordionHeader as="ldiv" onClick={() => handleClick(index)}>
                      <ToogleGroup as="ldiv">
                        <HostInfo as="ldiv">
                          <HostTitle as="ldiv">{host.name}</HostTitle>
                        </HostInfo>
                      </ToogleGroup>
                      <HostNotice as="ldiv">
                        <CookiesContainer as="ldiv">
                          <HostViewCookies color={appConfig.UIConfig.buttonBackgroundColor} as="ldiv">{getTranslation('VENDORS_LIST_BACK_SHOW_COOKIES')}</HostViewCookies>
                        </CookiesContainer>
                        <ArrowContainer as="ldiv">
                          <svg style={{top: '2px', position: 'relative', marginLeft: '5px', transform: `rotate(${index === selectedIndex ? 90 : 0}deg)`}} x="0px" y="0px" width="10px" height="10px" viewBox="0 0 451.846 451.847">
                            <g>
                              <path fill="#7b7b7b" d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744 L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284 c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path>
                            </g>
                          </svg>
                        </ArrowContainer>
                      </HostNotice>
                    </AccordionHeader>
                    {index === selectedIndex &&
                      <AccordionText as="ldiv">
                        <ldiv>
                          <HostOptionGroup as="ldiv">
                            {host.cookies.map((cookie, index) => (
                              <VendorHost key={index} as="ldiv">
                                <CookieDetail cookie={cookie}/>
                              </VendorHost>
                            ))}
                          </HostOptionGroup>
                        </ldiv>
                      </AccordionText>
                    }
                  </HostItem>
                ))}
              </HostListContainer>
            </Column>
          </Row>
        </VendorListContent>
      </VendorsContent>
    </VendorsContainer>
  );
}